import React, { forwardRef } from "react";
import { Checkbox, useTheme, TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

interface HeaderProps {
  regexSearch: boolean;
  setRegexSearch: (value: boolean) => void;
  searchText: string;
  handleSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  highlight: boolean;
  handleClear: () => void;
}

const Header = forwardRef<HTMLInputElement, HeaderProps>(
  
  (
    {
      regexSearch,
      setRegexSearch,
      searchText,
      handleSearchChange,
      highlight,
      handleClear,
    },
    ref
  ) => {
    
      const theme = useTheme();
      const isDarkMode = theme.palette.mode === "dark";
    return (
      <div className="search-header">
        <div className="search-header-left">
          <label className="regex-toggle">
            <Checkbox
              checked={regexSearch}
              onChange={(e) => setRegexSearch(e.target.checked)}
              className="regex-checkbox"
              sx={{ padding: "0px !important" }}
            />
            <span className="regex-label">Regex Search</span>
          </label>
        </div>
        <div className="search-header-right">
          <div className="serch-field">
            <TextField
              variant="outlined"
              autoFocus
              inputRef={ref}
              value={searchText}
              onChange={handleSearchChange}
              name="searchField"
              autoComplete="off"
              placeholder={
                regexSearch
                  ? "Search with regular expression"
                  : "What are you looking for?"
              }
              sx={{
                width: '100%',
                "& .MuiOutlinedInput-root": {
                  height: "36px",
                  minHeight: "36px",
                  paddingLeft: "8px",
                  paddingRight: "100px",
                  color: theme.palette.text.primary,
                  borderRadius: "6px",
                  backgroundColor: theme.palette.mode === 'dark' ? "rgba(255, 255, 255, 0.05)" : "rgba(0, 0, 0, 0.02)",
                  transition: "all 0.3s ease",
                  "& fieldset": {
                    borderColor: theme.palette.mode === 'dark' ? "rgba(255, 255, 255, 0.12)" : "rgba(0, 0, 0, 0.12)",
                    borderWidth: "1px",
                  },
                  "&:hover fieldset": {
                    borderColor: theme.palette.mode === 'dark' ? "rgba(255, 255, 255, 0.24)" : "rgba(0, 0, 0, 0.24)",
                  },
                  "&.Mui-focused": {
                    backgroundColor: theme.palette.mode === 'dark' ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.04)",
                    boxShadow: isDarkMode ? `0 0 0 2px ${theme.palette.primary.main}25` : "none",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: isDarkMode ? theme.palette.primary.main : (theme.palette.mode === 'dark' ? "rgba(255, 255, 255, 0.24)" : "rgba(0, 0, 0, 0.24)"),
                    borderWidth: "1px",
                  },
                },
                "& .MuiInputBase-input": {
                  color: theme.palette.text.primary,
                  lineHeight: "36px",
                  padding: "0px !important",
                  fontSize: "13px",
                  paddingLeft: "8px !important",
                  border: "none !important",
                  outline: "none !important",
                  boxShadow: "none !important",
                },
                "& .MuiInputBase-input::placeholder": {
                  color: theme.palette.text.secondary,
                  opacity: 0.8,
                  fontSize: "13px",
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ color: "text.secondary", fontSize: 20 }} />
                  </InputAdornment>
                ),
              }}
            />
            {searchText && searchText.length < 3 && (
              <span className="min-char-error">
                Enter Minimum 3 characters to get search results
              </span>
            )}
          </div>

          <div className="search-clear">
            <span
              className={highlight ? "search-text-highlight" : "search-text"}
            >
              Search
            </span>
            <button
              className="clear-btn"
              onClick={handleClear}
              disabled={!searchText || searchText.length === 0}
            >
              <ClearIcon fontSize="small" />
            </button>
          </div>
        </div>
      </div>
    );
  }
);

export default Header;
